import __request__ from "routing/request";
export function getMetrics(index_set_ids, fields, requestOptions) {
  return __request__("GET", "/system/indices/index_sets/metrics", null, { "index_set_ids": index_set_ids, "fields": fields }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
